<template>
  <HotelDatePicker
    format="DD/MM/YYYY"
    :startDate="null"
    :startingDateValue="privateStartDate"
    :endingDateValue="privateEndDate"
    @check-in-changed="changeDateFrom"
    @check-out-changed="changeDateTo"
    :i18n="dateRangeI18n"
  />
</template>

<style lang="scss">
// Vue hotel datepicker style
$indigo: #173d8f;
.datepicker__wrapper {
  position: relative;
  width: 280px !important;
  height: 35px !important;
  background: none !important;
  &:before {
    content: "\e927";
    font-family: icomoon;
    font-size: 22px;
    color: #b4b4b4;
    position: absolute;
    top: 1px;
    left: 120px;
  }
  .datepicker__month-day--hidden {
    border: none !important;
  }
  .datepicker__dummy-wrapper {
    border-radius: 8px;
    .datepicker__input {
      position: relative;
      width: 50%;
      height: 100%;
      line-height: 1;
      display: flex;
      align-items: center;
      background: none !important;
      &:focus {
        outline: none !important;
      }
      &:first-child {
        padding: 0 30px 0 30px;
      }
      &:first-child:before {
        content: "\e92e";
        font-family: icomoon;
        font-size: 22px;
        color: #b4b4b4;
        position: absolute;
        top: 5px;
        left: -13px;
      }
      &:last-child {
        padding: 0 30px 0 30px;
      }
      &:last-child:before {
        content: "\e92e";
        font-family: icomoon;
        font-size: 22px;
        color: #b4b4b4;
        position: absolute;
        top: 5px;
        left: 2px;
      }
    }
  }
  .datepicker__dummy-wrapper--is-active {
    border: 1px solid #d7d9e2 !important;
  }
  .datepicker__clear-button {
    width: 30px !important;
    height: 100%;
    margin: 0;
    svg {
      left: 5px;
      stroke: $indigo;
    }
  }
  .datepicker {
    border-radius: 8px;
    .datepicker__month-day--last-day-selected,
    .datepicker__month-day--first-day-selected {
      // background-color: #4563a5;
      background-color: $indigo;
      opacity: 1;
    }
    .datepicker__month-day--selected {
      background-color: $indigo;
      &:hover {
        color: white;
        box-shadow: 0px 0px 10px 3px rgba(255, 255, 255, 0.4);
      }
    }
    .datepicker__month-button {
      width: 30px;
    }
  }
}
</style>

<script>
import moment from "moment";

export default {
  props: {
    valueFormat: String,
    startDate: Date | String,
    endDate: Date | String
  },
  data() {
    return {
      privateStartDate: null,
      privateEndDate: null,
      dateRangeI18n: {
        night: "",
        nights: "",
        "day-names": [
          this.$t("_DATE_RANGE.MONDAY"),
          this.$t("_DATE_RANGE.TUESDAY"),
          this.$t("_DATE_RANGE.WEDNESDAY"),
          this.$t("_DATE_RANGE.THURSDAY"),
          this.$t("_DATE_RANGE.FRIDAY"),
          this.$t("_DATE_RANGE.SATURDAY"),
          this.$t("_DATE_RANGE.SUNDAY")
        ],
        "check-in": "",
        "check-out": "",
        "month-names": [
          this.$t("_DATE_RANGE.JAN"),
          this.$t("_DATE_RANGE.FEB"),
          this.$t("_DATE_RANGE.MAR"),
          this.$t("_DATE_RANGE.APR"),
          this.$t("_DATE_RANGE.MAY"),
          this.$t("_DATE_RANGE.JUN"),
          this.$t("_DATE_RANGE.JUL"),
          this.$t("_DATE_RANGE.AUG"),
          this.$t("_DATE_RANGE.SEP"),
          this.$t("_DATE_RANGE.OTC"),
          this.$t("_DATE_RANGE.NOV"),
          this.$t("_DATE_RANGE.DEC")
        ]
      }
    };
  },
  created() {
    if (this.valueFormat) {
      // let currentYear = moment().year();
      // let firstDayOfYear = `${currentYear}-01-01`;
      // this.privateStartDate = this.startDate
      //   ? moment(this.startDate, this.valueFormat).toDate()
      //   : moment(firstDayOfYear).format("YYYY-MM-DD");
      this.privateStartDate = this.startDate
        ? moment(this.startDate, this.valueFormat).toDate()
        : new Date();
      this.privateEndDate = this.endDate
        ? moment(this.endDate, this.valueFormat).toDate()
        : new Date(new Date().valueOf() + 1000 * 3600 * 24);
    } else {
      this.privateStartDate = this.startDate;
      this.privateEndDate = this.endDate;
    }
    this.$emit(
      "update:startDate",
      moment(this.privateStartDate).format("YYYY-MM-DD")
    );
    this.$emit(
      "update:endDate",
      this.privateEndDate == null
        ? null
        : moment(this.privateEndDate).format("YYYY-MM-DD")
    );
  },
  mounted() {
    let vm = this;
    window.addEventListener("click", function(e) {
      if (
        e.target.querySelector("div") &&
        e.target.querySelector("div").getAttribute("tabindex") == -1 &&
        !e.target
          .querySelector("div")
          .classList.contains("datepicker__month-day--hidden")
      ) {
        let target = document.querySelector(
          ".datepicker__input[tabindex='-1']"
        );
        if (target) {
          vm.changeDateTo(vm.startDate);
          target.innerText = moment(vm.startDate).format("DD/MM/YYYY");
          let datepicker = document.querySelector(".datepicker--open");
          if (datepicker) {
            datepicker.classList.remove("datepicker--open");
            datepicker.classList.add("datepicker--closed");
          }
        }
      }
    });
  },
  methods: {
    changeDateFrom(date) {
      if (date) {
        const result = this.valueFormat
          ? moment(date).format(this.valueFormat)
          : date;
        this.$emit("update:startDate", result);
      } else {
        this.$emit("update:startDate", null);
      }
    },
    changeDateTo(date) {
      if (date) {
        const result = this.valueFormat
          ? moment(date).format(this.valueFormat)
          : date;
        this.$emit("update:endDate", result);
      } else {
        this.$emit("update:endDate", null);
      }
    }
  }
};
</script>